import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { getDefaultDelegateMeeting_action, getDelegateMeetingDetails_action, insertUpdateDelegateMeeting_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/delegate_meeting_action/delegate_meeting_action'
import Modal from "react-modal";
import { data } from "jquery";
import $ from 'jquery'
import { Tab, Nav } from "react-bootstrap";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
// 
class DelegateMeeting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      delegateMeetingList: [],
      currentDelegateMeetingList: [],
      countryList: [],
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
    };
    this.handleCancel = this.handleCancel.bind(this)
    this.getDefaultDelegateMeeting = this.getDefaultDelegateMeeting.bind(this)
    this.updateList = this.updateList.bind(this)
    this.handleBookMeeting = this.handleBookMeeting.bind(this)

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleBookMeeting(popArg[0], popArg[1])
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getDefaultDelegateMeeting()
    this.loadscript()
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back()
  }

  getDefaultDelegateMeeting() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getDefaultDelegateMeeting_action()
      .then((data) => {
        if (data.error != 1) {
          console.log(data)
          var countryList = ['All']
          for (var i = 0; i < data.data.length; i++) {
            if (!countryList.includes(data.data[i].CountryName)) {
              countryList.push(data.data[i].CountryName)
            }
          }
          this.setState({
            delegateMeetingList: data.data,
            countryList: countryList,
            currentDelegateMeetingList: data.data,
          })
          this.setState({ isLoading: false })
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  updateList(country) {
    const { countryList, delegateMeetingList } = this.state
    var list = []
    if (country != 'All') {
      for (var i = 0; i < delegateMeetingList.length; i++) {
        if (delegateMeetingList[i].CountryName == country) {
          list.push(delegateMeetingList[i])
        }
      }
    }
    else {
      list = [...delegateMeetingList]
    }
    this.setState({ currentDelegateMeetingList: list })
  }

  handleBookMeeting(id, country) {
    const { DeadlineDate, StatusID } = this.state
    this.props.navigate('/delegateMeetingAU', {
      state: {
        Deadline: DeadlineDate, delegateMeetingID: id, country: country, StatusID: StatusID
      }
    })

  }

  // addCarPassessApplication() {
  //     const { Remark, Is_Agree, isQuantity, Is_Required, carPassessId } = this.state
  //     this.inputValidate()
  //     this.setState({ isLoading: true })
  //     if (Is_Agree) {
  //         this.props
  //             .insertUpdateCarPassessApplication_action(isQuantity,
  //                 Is_Required == 1 ? true : false,
  //                 Remark, Is_Agree, carPassessId)
  //             .then((data) => {
  //                 if (data.error != 1) {
  //                     this.setState({ isLoading: false })
  //                     this.handleCancel()
  //                 }
  //                 else {
  //                     this.setState({ isLoading: false })
  //                     toastError(data.msg)
  //                 }
  //             })
  //             .catch((e) => {
  //                 console.log(e);
  //             });
  //     } else {
  //         this.inputValidate()
  //         this.setState({ isLoading: false })
  //     }
  // }

  render() {
    const { isLoading, currentDate, DeadlineDate, isOpenConfirmationModal, countryList, currentDelegateMeetingList, delegateMeetingList, is_View, isHideSection } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div>
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div>
              <div className="row m-0">
                <div class="card rounded-0 border shadow-none p-0">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Delegate Meeting
                    </h3>
                  </div>
                  <Tab.Container defaultActiveKey={"All"} className="mt-2">
                    <div className="mt-3">
                      <Nav
                        variant="pills"
                        className="nav nav-tabs-custom nav-success "
                        role="tablist"
                      >
                        {countryList.length > 0 &&
                          countryList.map((data) => (
                            <Nav.Item>
                              <Nav.Link eventKey={data} onClick={() => this.updateList(data)}>
                                <i className="ri-store-2 me-1 align-bottom" /> {data}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                      </Nav>
                      <Tab.Content>
                        <div class="card-body p-1">
                          <div class="table-responsive">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th> Name || Company</th>
                                  <th class="text-center"> Designation</th>
                                  <th class="text-center"> Country</th>
                                  <th class="text-center"> Book Meeting</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentDelegateMeetingList.length > 0 &&
                                  currentDelegateMeetingList.map((data) => (
                                    <tr key={data.DelegateMeetingID}>
                                      <td>
                                        {data.PersonInchargeName} || {data.CompanyName}{" "}
                                      </td>
                                      <td class="text-center">{data.Designation} </td>
                                      <td class="text-center">{data.CountryName} </td>
                                      <td class="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-aqua"
                                          onClick={() => this.setState({
                                            isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to   Book Meeting?', buttonName: '  Book Meeting', action: 0 }, popArg: [data.DelegateMeetingID, data.CountryName]
                                          })}
                                        // onClick={(e) =>
                                        //   this.handleBookMeeting(
                                        //     data.DelegateMeetingID,
                                        //     data.CountryName
                                        //   )
                                        // }
                                        >
                                          Book Meeting{" "}
                                          {/* {data.isBooked == 1 ? 'Edit' : '  Book Meeting'} */}
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
              </div>
              {!isHideSection && (
                <div className="row m-0">
                  {isDeadlinePassed ? (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  ) : null}
                </div>
              )}
              {!isHideSection && (
                <div className="d-flex justify-content-end mt-0">
                  <button
                    className="btn btn-gray rounded-1 d-block"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { getDefaultDelegateMeeting_action, getDelegateMeetingDetails_action, insertUpdateDelegateMeeting_action })(DelegateMeeting));